(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ext/dhtmlxgantt_keyboard_navigation", [], factory);
	else if(typeof exports === 'object')
		exports["ext/dhtmlxgantt_keyboard_navigation"] = factory();
	else
		root["ext/dhtmlxgantt_keyboard_navigation"] = factory();
})(window, function() {
return 